import { securityMcpOAuthApprovePostAsyncSlice } from './approve';
import { securityMcpOAuthDenyPostAsyncSlice } from './deny';

export const {
	requestPostSecurityMcpOAuthApprove,
	resetPostSecurityMcpOAuthApprove
} = securityMcpOAuthApprovePostAsyncSlice.asyncActionCreators;

export const {
	requestPostSecurityMcpOAuthDeny,
	resetPostSecurityMcpOAuthDeny
} = securityMcpOAuthDenyPostAsyncSlice.asyncActionCreators;
